<template>
  <button
    class="video-card"
    @click="showModal(true)"
    @mouseenter="videoPlaying = true"
    @mouseleave="videoPlaying = false"
  >
    <TvaBackgroundVideo
      :pathToVideo="videoFileName"
      :playing="videoPlaying"
      preload="metadata"
    />

    <VideoCardContent
      :title="title"
      :labels="labels"
      :duration="videoDuration"
    />
    <RoundIconButton class="video-card__play-btn" :icon="play" white />

    <VideoModal
      :show="modalShown"
      :videoPath="videoFileName"
      @onClose="showModal(false)"
    />
  </button>
</template>

<script setup>
import { ref, inject, computed, onMounted } from "vue";
import { pushData } from "@/utilities/analytics-functions.js";

import VideoCardContent from "./VideoCardContent.vue";
import TvaBackgroundVideo from "./TvaBackgroundVideo.vue";
import RoundIconButton from "./RoundIconButton.vue";
import VideoModal from "../general/VideoModal.vue";

import { play } from "@/assets/icons/icons.js";

const props = defineProps({
  title: String,
  labels: {
    type: Array,
    default: () => [],
  },
  videoFileName: String,
});

const $baseUrl = inject("$baseUrl");
const modalShown = ref(false);
const videoDuration = ref(0);
const videoPlaying = ref(false);

const videoPath = computed(
  () => `${$baseUrl}videos/${props.videoFileName}.mp4`
);

onMounted(() => getVideoDuration());

function showModal(value) {
  modalShown.value = value;
  pushData("video", videoPath.value, props.title);
}

function getVideoDuration() {
  const videoEl = document.createElement("video");
  videoEl.src = videoPath.value;
  videoEl.preload = "metadata";

  videoEl.onloadedmetadata = function () {
    window.URL.revokeObjectURL(videoPath.value);
    videoDuration.value = videoEl.duration;
  };

  videoEl.remove();
}
</script>

<style lang="scss" scoped>
.video-card {
  @include gradient-overlay;

  .mobile & {
    &::after {
      background-image: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 16.67%,
        #000000 100%
      );
    }
  }

  color: var(--white-100);
  width: toRem(608);
  height: toRem(380);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: left;

  .mobile & {
    width: 100%;
    height: auto;
    aspect-ratio: 1.2;
  }

  &__play-btn {
    .desktop &,
    .large & {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .mobile &,
    .tablet & {
      position: relative;
      z-index: 1;
      margin-left: 1.5rem;
      margin-bottom: 0.5rem;
    }
  }
}
</style>
